import { trimEnd, trimStart } from 'lodash-es';

export const pathWithParameters = (
  url: string,
  parameters: Record<string, unknown>,
  preserveParameters: Array<string> = [],
): string => {
  const currentUrl = new URL(window.location.href);
  const newUrl = new URL(url, `${window.location.protocol}//${window.location.host}`);

  for (const [key, value] of Object.entries(parameters)) {
    if (value === null) {
      newUrl.searchParams.delete(key);
    } else {
      newUrl.searchParams.set(key, String(value));
    }
  }

  for (const parameter of preserveParameters) {
    if (currentUrl.searchParams.has(parameter)) {
      newUrl.searchParams.set(parameter, currentUrl.searchParams.get(parameter) ?? '');
    }
  }

  return `${newUrl.pathname}${newUrl.search}${newUrl.hash}`;
};

/** Replaces the last segment of `pathname` with `segment`, ignoring a trailing slash. */
export const siblingPathname = (pathname: string, segment: string): string => {
  const parentPathname = trimEnd(pathname, '/');
  return `${parentPathname.slice(0, parentPathname.lastIndexOf('/'))}/${segment}`;
};

interface HrefIsActiveOptions {
  href: string;
  pathname: string;
}

export const hrefIsActive = ({ href, pathname }: HrefIsActiveOptions): boolean => {
  const nonRelativeHref = href.replaceAll('.', '');
  const normalizedHref = trimStart(
    nonRelativeHref[0] === '/' ? nonRelativeHref.slice(1) : nonRelativeHref,
  );

  return pathname.includes(`${normalizedHref}`);
};
